import { observer } from 'mobx-react';
import React from 'react';
import { SidebarStore } from '../SidebarStore';
import { CollapsibleMenu } from '../CollapsibleMenu';
import { TreeComponent } from '../menu/TreeComponent';
import { useTranslation } from 'react-i18next';

function SidebarStudentComponent(props: { store: SidebarStore }) {
    const store = props.store;
    const fullName = store.userStatus.user?.FirstName + ' ' + store.userStatus.user?.LastName;
    const email = store.userStatus.user?.Email;
    const completedLessons = store.userStatus.user?.Student?.CompletedLessons;
    const totalLessons = store.userStatus.user?.Student?.TotalLessons;
    const tzOffsetMinutes = (store.userStatus.user?.TimeZone?.UtcOffsetMinutes ?? 0) / 60;
    const tt = formatTimezoneOffset(tzOffsetMinutes);
    const tzName = store.userStatus.user?.TimeZone?.Name + ` (UTC ${tt})`;
    const { t } = useTranslation();
    const publicUrlProfilePhoto = store.userStatus.user?.ProfilePhotoUrl;

    function formatTimezoneOffset(minutes: number): string {
        var date = new Date(0);
        date.setMinutes(Math.abs(minutes));
        var timeString = date.toISOString().substr(14, 5);
        var sign = minutes >= 0 ? '+' : '-';
        return sign + timeString;
    }

    return (
        <div className="student-sidebar">
            <div className="studentMenu">
                <div className="studentAvatar">
                    {
                        publicUrlProfilePhoto != undefined
                        ? <img src={`${publicUrlProfilePhoto}?v=${new Date().getTime()}`} className='student-profile-photo' />
                        : <i className="fas fa-user-graduate"></i>
                    }                    
                </div>
                <div className="studentName">
                    <h4>{fullName}</h4>
                    <a href={`/student/profile/${store.userStatus.user?.Id}`}>{t('sidebar.edit-profile')}</a>
                    <span><i className="fas fa-map-marker-alt"></i>{tzName}</span>
                    <span>{email}</span>
                </div>
                <div className="studentStats">
                    <ul>
                        <li>
                            <span><i className="fas fa-tasks"></i></span>
                            <p>{t('sidebar.completed')}</p>
                            <span>{completedLessons}</span>
                        </li>
                        <li>
                            <span><i className="fas fa-chalkboard-teacher"></i></span>
                            <p>{t('sidebar.total-lessons')}</p>
                            <span>{totalLessons}</span>
                        </li>
                    </ul>
                </div>

            </div>
            <CollapsibleMenu label={t('sidebar.student-menu')}>
                <TreeComponent tree={store.studentMenu} />
            </CollapsibleMenu>
        </div>
    );
}

export const SidebarStudent = observer(SidebarStudentComponent);